import styled from 'styled-components';

export const Nav = styled.div`
    height:70px;
    box-shadow: 0 0 5px rgba(0, 0, 0, 0.322);
    background-color:#111214;
    position:fixed;
    top:0;
    width:100%;
    z-index:100;

    @media screen and (max-width: 550px){
        height:60px;

    }
`;

export const NavContainer = styled.div`
    max-width:1200px;
    height: 100%;
    margin: auto;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-left:20px;
    padding-right:20px ;
`;

export const NavStart = styled.div`
    a{
        text-decoration: none;
        outline: none;
    }
`;

export const NavHeading = styled.div`
    display:flex;
    flex-direction:row;
    align-items:center;
`;

export const NavEnd = styled.div`
display:flex;
align-items:center;
`;

export const NavMenu = styled.div`
margin-left:30px;
@media screen and (max-width: 550px){
        display:none;

    }
`;

export const SideNavMenu = styled.div``;

export const Button = styled.div`
    background:#dc3545;
    padding:5px 10px;
    border-color:#007bff;
    border-radius:5px;
    font-family:'Open Sans';
    color:white;
    font-size:15px;
    cursor: pointer;

    &:hover{
        background:#C82333;
    }
`;

export const GitHeader = styled.div`
@media screen and (max-width: 550px){
        display:none;

    }

`;

export const GitHub = styled.img`
filter: invert(100%) sepia(100%) saturate(1%) hue-rotate(37deg) brightness(104%) contrast(101%);
`;

export const NavLinks = styled.div`
    display:flex;
    flex-direction:row;
    align-items:flex-end;
    justify-content:flex-end;
    width:225px;
    @media screen and (max-width: 550px){
        display:none;
    }
`;

export const SideNavLink = styled.p`
    margin:20px;
    font-size:20px;
    font-family:'Open Sans';
    color:white;
    text-decoration:none;
`;

export const AboutLink = styled.p`
    font-family:'Open Sans';
    color:white;
    margin-left:40px;
`;

export const NavLogo = styled.img`
width:40px;
z-index:100;
@media screen and (max-width: 550px){
width:30px;

    }
`;

export const Hamburger = styled.div`
display:none;

@media screen and (max-width: 550px){
        display:block;
        cursor: pointer;
        outline:none;
        margin:5px;

    }
`;

export const SideNav = styled.div`
    width:${({open})=> (open ? '70%' : '0px')};
    overflow:hidden;
    position:fixed;
    left:0;
    top:0;
    background-color:black;
    height:100vh;
    z-index:20;
    display:flex;
    align-items:center;
    justify-content:flex-start;
    flex-direction:column;
    transition:0.3s;
`;

export const Burger = styled.div`
height:3px;
width:28px;
background:white;
margin:6px;
outline:none;
`;

export const SideNavLogo = styled.img`
    width:40px;
    margin:20px;
    margin-top:50px;
`;

export const GithubButton = styled.button`
    width:150px;
    height:50px;
    border-radius:50px;
    border:0;
    background:white;
    display:flex;
    justify-content:flex-start;
    align-items:center;
    font-size:20px;
    font-weight:500;
    text-align:center;
    cursor: pointer;
    margin:20px;
`;

export const SideNavGit = styled.img`
    width:40px;
    margin:5px;
    margin-top:5px;
    margin-right:15px;
`;